import type React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Button from '../../../Button';

interface HookArrayProps {
  name: string;
  id?: string;
  children?: (arrayFieldName: string, removeButton: React.ReactNode, arrayId: string) => any;
  className?: string;
  addButtonLabel?: string;
  fixedSize?: boolean;
  minArrayLength?: number;
  maxArrayLength?: number;
  defaultValues: Record<string, any>;
}
export const HookArray = (props: HookArrayProps) => {
  const {
    children,
    className = '',
    name,
    addButtonLabel = 'Add',
    fixedSize = false,
    minArrayLength = 0,
    maxArrayLength,
    id,
    defaultValues,
  } = props;
  const idOrName = id || name;

  if (typeof children !== 'function') {
    throw new Error('Children should be a function');
  }
  const { control, watch } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name,
    keyName: 'id',
  });

  const watchFieldArray = watch(name);
  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });
  const shouldDisplayAdd = () => {
    if (maxArrayLength) {
      return controlledFields.length < maxArrayLength;
    }
    return true;
  };
  return (
    <div className={`${className}`} id={idOrName}>
      {controlledFields.map((field, index) => (
        <div className={`w-full relative my-4 pb-4 ${fixedSize === false ? 'border-b' : ''}`} key={field.id || `${name}.${index}.`}>
          {!fixedSize && (
            <div className={`w-full ${index > 0 ? 'py-6' : 'pb-6'} flex justify-center`}>
              <p
                className='bg-primaryColor-normal font-bold text-white p-2 rounded-full flex justify-center'
                style={{ width: '38px', height: '38px' }}
              >
                {index + 1}
              </p>
            </div>
          )}
          {children(
            `${name}.${index}.`,
            index > minArrayLength - 1 ? (
              <button
                type='button'
                className='absolute right-0 top-0 hover:text-tertiaryColor-normal'
                onClick={(e) => {
                  e.preventDefault();
                  remove(index);
                }}
              >
                &#10005; Remove
              </button>
            ) : undefined,
            field.arrayId
          )}
        </div>
      ))}
      {!fixedSize && shouldDisplayAdd() && (
        <div className='w-full flex justify-center py-6'>
          <Button
            label={`✚ ${addButtonLabel}`}
            btnStyle='btn-primary'
            type='button'
            onClick={(e) => {
              e.preventDefault();
              append({
                ...defaultValues,
                arrayId: `${Date.now()}`,
              });
            }}
          />
        </div>
      )}
    </div>
  );
};
